<template>
  <div class="cookie__button">
    <button
      class="cookie__button-label"
      tabindex="0"
      role="button"
      aria-pressed="true"
      @click="accept"
      @mouseenter="$store.commit('SET_POINTER', 'pointer')"
      @mouseleave="$store.commit('SET_POINTER', 'default')"
    >
      {{ label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'CookieButton',

  props: {
    label: {
      type: String,
      required: true,
    },
  },

  methods: {
    accept() {
      localStorage.setItem('cookie:accepted', '1');
      this.$parent.$emit('cookie-accepted');
      this.$store.commit('SET_POINTER', 'default');
    },
  },
};
</script>

<style lang="scss" scoped>
.cookie__button button {
  cursor: none;

  @at-root [data-theme="default"] & {
    font-family: 'GT America';
    text-transform: uppercase;
    margin-left: 20px;
    padding: 5px 15px;
    font-size: 16px;
    font-weight: normal;
    background-color: $color-white;
    color: $color-dark;
    text-align: center;
    border: none;
    -webkit-appearance: none;
    appearance: none;
  }
}
</style>
